export const FETCH_SETTING_CURRENT = "FETCH_SETTING_CURRENT";
export const FETCH_SETTING_MOTHER = "FETCH_SETTING_MOTHER";

